import api from '../../api';

export class SalaBancaViewModel {

    static async getSalaBanca(processoId: string, bancaId: string): Promise<string | null> {
        try {
            const response = await api.get(`/processos/${processoId}/bancas/${bancaId}/salaDeBanca`);
            const link = response.data.link;
            if (typeof link === 'string') {
                return link;
            } else {
                console.error('Link is not a string:', link);
                return null;
            }
        } catch (error) {
            console.error('Erro ao convocar Banca:', error);
            return null;
        }
    }
    static async patchSalaBanca(processoId: string, bancaId: string, url: string): Promise<void> {
        await api.patch(`/processos/${processoId}/bancas/${bancaId}/salaDeBanca`, { link: url });
    }
    
    
}